import { AuthApiError } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';

import { supabaseClient } from 'src/auth/supabase';

export const usePasswordLoginSupabase = () =>
    useMutation<unknown, AuthApiError, { email: string; password: string }>({
        mutationKey: ['auth', 'password', 'login'],
        mutationFn: async ({ email, password }) => {
            const res = await supabaseClient.auth.signInWithPassword({
                email,
                password,
            });

            if (res.error) throw res.error;

            return res.data;
        },
    });
